// 17 Locales: 12 EU + 5 Asien/RTL (ja, zh-CN, ko, th, he).
// TH + HE haben aktuell keine eigene .json-Datei — sie greifen via resolveKey
// auf den DE-Fallback zu. Volle Asien-Translation kommt in R28+ via
// section-by-section-Subagents (~200 Keys pro Run um Stalls zu vermeiden).
// Hebrew (he) loest via i18n/client.tsx automatisch dir="rtl" + Heebo-Fontstack
// aus den :root[lang="he"]-CSS-Regeln.
export const locales = [
  'de', 'en', 'fr', 'it', 'es', 'pt', 'nl', 'da', 'fi', 'pl', 'sv', 'sl',
  'ja', 'zh-CN', 'ko', 'th', 'he',
] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'de'
